const Routes = Object.freeze({
  LANDING: '/',
  GYMS: '/gyms',
  DASHBOARD: '/gyms',
  OWNER_ONBOARDING: '/owner-onboarding',
  ADMIN_GYM_OWNERS: '/admin-dashboard/gym-owners',
  ADMIN_GYM_GOERS: '/admin-dashboard/gym-goers',
  ADMIN_SUBSCRIPTIONS: '/admin-dashboard/subscriptions',
  ADMIN_CREATE_FULL_LISTING: '/admin-dashboard/create-full-listing',
  ADMIN_EDIT_FULL_LISTING: '/admin-dashboard/edit-listing/:gymId',
  ADMIN_CREATE_ACCOUNT: '/admin-dashboard/create-account',
  ADMIN_AUDIT_LOGS: '/admin-dashboard/audit-logs',
  OWNER_LISTING_STATUS: '/owner-dashboard/listing-status',
  OWNER_PROFILE_VISITS: '/owner-dashboard/profile-visits',
  OWNER_SUBSCRIPTION: '/owner-dashboard/subscription',
  OWNER_DAY_PASS_BOOKINGS: '/owner-dashboard/day-passes',
  OWNER_PREVIEW: '/owner-dashboard/preview',
  LOGIN: '/login',
  REGISTER: '/register',
  REGISTER_OWNER: '/register/owner',
  FORGOT_PASSWORD: '/forgot-password',
  RESET_PASSWORD: '/reset-password',
  CONFIRM_EMAIL: '/confirm-email',
  GOER_DASHBOARD: '/dashboard',
  GOER_SAVED_GYMS: '/dashboard/saved-gyms',
  GOER_DAY_PASS_BOOKINGS: '/dashboard/day-passes',
  SUBSCRIPTION: '/subscription',
  PAYMENT_SELECT: '/payment-select',
  EMAIL_TEMPLATE: '/email-template',
  PASSWORD_CHANGED_CONFIRMATION: '/password-changed',
  EMAIL_CHANGED_CONFIRMATION: '/email-changed',
  GYM_DETAILS: '/gym/:id',
  GYMS_COMPARE: '/compare',
  MANAGE_LISTING: '/owner-dashboard/manage-listing',
  CALLBACK_AUTH: '/auth/callback',
  ASSISTED_LISTING_CONFIRMATION: '/assisted-listing-confirmation',
} as const);

export default Routes;

export type AvailableRoutes = (typeof Routes)[keyof typeof Routes];
